import { useCallback, useContext, useEffect, useState } from "react";
import { Context } from "states/Store";

import { createRestrictedToken,} from "services/edge/OwlinService";

const OwlinWidget = ({ owlinData, thirdPartyId }) => {
    const [state, ] = useContext(Context);
    const [restrictedToken, setRestrictedToken] = useState();

    const getRestrictedToken = useCallback(async () => {
        try {
            const token = await createRestrictedToken(
                state.account.id,
                thirdPartyId
            );
            setRestrictedToken(token?.content);
        } catch (error) {
            console.error(error);
        }
    }, [state.account.id, thirdPartyId])

    useEffect(() => {
        if (state.account.id && thirdPartyId) {
            getRestrictedToken();
        }
    }, [state.account.id, thirdPartyId, getRestrictedToken]);

    return (
        <div>
            {restrictedToken && (
                <>
                    <aprovall-owlin
                        entity={owlinData?.entityId}
                        token={restrictedToken}
                        lang={state.lang}
                        layout="top"
                        rank="score" //alternative value : total
                        mode="signals" //alternative value : summary
                    />
                </>
            )}
        </div>

    )

}
export default OwlinWidget;